(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('[data-sw-drawer]');
    var openBtns = document.querySelectorAll('[data-sw-drawer-open]');
    var closeBtns = document.querySelectorAll('[data-sw-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Desktop category / nav dropdowns
    var catItems = document.querySelectorAll('[data-sw-cat]');

    function closeAllPanels(except) {
      catItems.forEach(function (item) {
        if (item !== except) {
          item.classList.remove('sw-open');
          var trigger = item.querySelector('[data-sw-cat-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    catItems.forEach(function (item) {
      var trigger = item.querySelector('[data-sw-cat-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('sw-open');
        closeAllPanels(item);
        item.classList.toggle('sw-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function (e) {
      var withinCat = e.target.closest('[data-sw-cat]');
      if (!withinCat) closeAllPanels();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });

    // Keep cart badge in sync after cart/ajax updates
    document.addEventListener('cart:updated', function (e) {
      var count = e.detail && typeof e.detail.itemCount === 'number' ? e.detail.itemCount : null;
      if (count === null) return;
      document.querySelectorAll('[data-sw-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    });
  });
})();